// export const API_URL = `http://localhost:8211`;
//export const API_URL = `https://stagapi.batterseahouse.co.uk`;
export const API_URL = `https://api.batterseahouse.co.uk`;

//export const Socket_Port = 3003; // stage port of socket
export const Socket_Port = 3004; // live port of socket

export const STRIPE_KEY_PUBLIC =
  "pk_live_51NuNkWLPhlHtBMFc0DFPKazH4nBfnod0kOtBSLAt51K3uYVW6qIjYbKlIg9oYBcoh8pe88w4X0Ge5xsScvYDPdhy001sBo8iBG";
